import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_ATTACHMENT_TEMPLATES = 'GET_ATTACHMENT_TEMPLATES';
export const GET_ATTACHMENT_TEMPLATE = 'GET_ATTACHMENT_TEMPLATE';
export const CREATE_ATTACHMENT_TEMPLATE = 'CREATE_ATTACHMENT_TEMPLATE';
export const UPDATE_ATTACHMENT_TEMPLATE = 'UPDATE_ATTACHMENT_TEMPLATE';
export const DELETE_ATTACHMENT_TEMPLATES = 'DELETE_ATTACHMENT_TEMPLATES';
export const SET_CURRENT_ATTACHMENT_TEMPLATE =
  'SET_CURRENT_ATTACHMENT_TEMPLATE';
export const UNSET_CURRENT_ATTACHMENT_TEMPLATE =
  'UNSET_CURRENT_ATTACHMENT_TEMPLATE';
export const CLEAR_ATTACHMENT_TEMPLATE_ERROR =
  'CLEAR_ATTACHMENT_TEMPLATE_ERROR';

export const CLEAR_ATTACHMENT_TEMPLATE_STORE =
  'CLEAR_ATTACHMENT_TEMPLATE_STORE';

export const WARN_AND_ARCHIVE_ATTACHMENT_TEMPLATE =
  'WARN_AND_ARCHIVE_ATTACHMENT_TEMPLATE';

export const GET_PAGINATED_ATTACHMENT_TEMPLATES =
  'GET_PAGINATED_ATTACHMENT_TEMPLATES';

export const GET_MINIMAL_ATTACHMENT_TEMPLATES = 'GET_MINIMAL_ATTACHMENT_TEMPLATES';
export const GET_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS =
  'GET_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS';

export const GET_ATTACHMENT_TAGS = 'GET_ATTACHMENT_TAGS';
export const GETTING_ATTACHMENT_TAGS = 'GETTING_ATTACHMENT_TAGS';
export const GETTING_ATTACHMENT_TAGS_FAILED = 'GETTING_ATTACHMENT_TAGS_FAILED';
export const GETTING_ATTACHMENT_TAGS_SUCCEEDED =
  'GETTING_ATTACHMENT_TAGS_SUCCEEDED';

// async actions
export const GETTING_ATTACHMENT_TEMPLATES = 'GETTING_ATTACHMENT_TEMPLATES';
export const GETTING_ATTACHMENT_TEMPLATES_SUCCEEDED =
  'GETTING_ATTACHMENT_TEMPLATES_SUCCEEDED';
export const GETTING_ATTACHMENT_TEMPLATES_FAILED =
  'GETTING_ATTACHMENT_TEMPLATES_FAILED';

export const GETTING_PAGINATED_ATTACHMENT_TEMPLATES =
  'GETTING_PAGINATED_ATTACHMENT_TEMPLATES';
export const GETTING_PAGINATED_ATTACHMENT_TEMPLATES_SUCCEEDED =
  'GETTING_PAGINATED_ATTACHMENT_TEMPLATES_SUCCEEDED';
export const GETTING_PAGINATED_ATTACHMENT_TEMPLATES_FAILED =
  'GETTING_PAGINATED_ATTACHMENT_TEMPLATES_FAILED';

export const GETTING_MINIMAL_ATTACHMENT_TEMPLATES = 'GETTING_MINIMAL_ATTACHMENT_TEMPLATES';
export const GETTING_MINIMAL_ATTACHMENT_TEMPLATES_SUCCEEDED = 'GETTING_MINIMAL_ATTACHMENT_TEMPLATES_SUCCEEDED';
export const GETTING_MINIMAL_ATTACHMENT_TEMPLATES_FAILED = 'GETTING_MINIMAL_ATTACHMENT_TEMPLATES_FAILED';
export const GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS =
  'GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS';
export const GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED =
  'GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED';
export const GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_FAILED =
  'GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_FAILED';

export const GETTING_ATTACHMENT_TEMPLATE = 'GETTING_ATTACHMENT_TEMPLATE';
export const GETTING_ATTACHMENT_TEMPLATE_FAILED =
  'GETTING_ATTACHMENT_TEMPLATE_FAILED';
export const GETTING_ATTACHMENT_TEMPLATE_SUCCEEDED =
  'GETTING_ATTACHMENT_TEMPLATE_SUCCEEDED';

export const CREATING_ATTACHMENT_TEMPLATE = 'CREATING_ATTACHMENT_TEMPLATE';
export const CREATING_ATTACHMENT_TEMPLATE_SUCCEEDED =
  'CREATING_ATTACHMENT_TEMPLATE_SUCCEEDED';
export const CREATING_ATTACHMENT_TEMPLATE_FAILED =
  'CREATING_ATTACHMENT_TEMPLATE_FAILED';

export const UPDATING_ATTACHMENT_TEMPLATE = 'UPDATING_ATTACHMENT_TEMPLATE';
export const UPDATING_ATTACHMENT_TEMPLATE_SUCCEEDED =
  'UPDATING_ATTACHMENT_TEMPLATE_SUCCEEDED';
export const UPDATING_ATTACHMENT_TEMPLATE_FAILED =
  'UPDATING_ATTACHMENT_TEMPLATE_FAILED';

export const DELETING_ATTACHMENT_TEMPLATES = 'DELETING_ATTACHMENT_TEMPLATES';
export const DELETING_ATTACHMENT_TEMPLATES_SUCCEEDED =
  'DELETING_ATTACHMENT_TEMPLATES_SUCCEEDED';
export const DELETING_ATTACHMENT_TEMPLATES_FAILED =
  'DELETING_ATTACHMENT_TEMPLATES_FAILED';

export const ATTACHMENT_AUTO_SAVE_TIMER_START =
  'ATTACHMENT_AUTO_SAVE_TIMER_START';
export const ATTACHMENT_AUTO_SAVE_TIMER_END = 'ATTACHMENT_AUTO_SAVE_TIMER_END';

export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_SUCCEEDED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_SUCCEEDED';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_FAILED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_FAILED';

export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const UNSET_NEXT_STEP = 'UNSET_NEXT_STEP';

export const SET_COPY_CURRENT_ATTACHMENT_TEMPLATE =
  'SET_COPY_CURRENT_ATTACHMENT_TEMPLATE';

export const UPDATE_ATTACHMENT_FILTERS = 'UPDATE_ATTACHMENT_FILTERS';
// Test attachment template actions (matches print template pattern)
export const GET_ATTACHMENT_TEMPLATE_FILE = 'GET_ATTACHMENT_TEMPLATE_FILE';
export const GETTING_ATTACHMENT_TEMPLATE_FILE_SUCCEEDED = 'GETTING_ATTACHMENT_TEMPLATE_FILE_SUCCEEDED';
export const GETTING_ATTACHMENT_TEMPLATE_FILE_FAILED = 'GETTING_ATTACHMENT_TEMPLATE_FILE_FAILED';
export const DOWNLOADED_ATTACHMENT_TEMPLATE_FILE = 'DOWNLOADED_ATTACHMENT_TEMPLATE_FILE';
export const SET_ATTACHMENT_TEST_DOWNLOAD = 'SET_ATTACHMENT_TEST_DOWNLOAD';

export const RESET_ATTACHMENT_FILTERS = 'RESET_ATTACHMENT_FILTERS';

export const getAttachmentTemplates = createAction(GET_ATTACHMENT_TEMPLATES);

export const getAttachmentTemplate = createAction(GET_ATTACHMENT_TEMPLATE);

export const createAttachmentTemplate = createAction(
  CREATE_ATTACHMENT_TEMPLATE
);

export const updateAttachmentTemplate = createAction(
  UPDATE_ATTACHMENT_TEMPLATE
);

export const deleteAttachmentTemplates = createAction(
  DELETE_ATTACHMENT_TEMPLATES
);

export const warnAndArchiveAttachmentTemplate = createAction(
  WARN_AND_ARCHIVE_ATTACHMENT_TEMPLATE
);

export const setCurrentAttachmentTemplate = createAction(
  SET_CURRENT_ATTACHMENT_TEMPLATE
);

export const unsetCurrentAttachmentTemplate = createAction(
  UNSET_CURRENT_ATTACHMENT_TEMPLATE
);

export const clearTemplateAttachmentError = createAction(
  CLEAR_ATTACHMENT_TEMPLATE_ERROR
);

export const clearAttachmentTemplateStore = createAction(
  CLEAR_ATTACHMENT_TEMPLATE_STORE
);

export const gettingAttachmentTemplates = createAction(
  GETTING_ATTACHMENT_TEMPLATES
);

export const gettingAttachmentTemplatesSucceeded = createAction(
  GETTING_ATTACHMENT_TEMPLATES_SUCCEEDED
);

export const gettingAttachmentTemplatesFailed = createAction(
  GETTING_ATTACHMENT_TEMPLATES_FAILED
);

export const gettingPaginatedAttachmentTemplates = createAction(
  GETTING_PAGINATED_ATTACHMENT_TEMPLATES
);

export const gettingPaginatedAttachmentTemplatesSucceeded = createAction(
  GETTING_PAGINATED_ATTACHMENT_TEMPLATES_SUCCEEDED
);

export const gettingPaginatedAttachmentTemplatesFailed = createAction(
  GETTING_PAGINATED_ATTACHMENT_TEMPLATES_FAILED
);

export const gettingMinimalAttachmentTemplates = createAction(
  GETTING_MINIMAL_ATTACHMENT_TEMPLATES
);

export const gettingMinimalAttachmentTemplatesSucceeded = createAction(
  GETTING_MINIMAL_ATTACHMENT_TEMPLATES_SUCCEEDED
);

export const gettingMinimalAttachmentTemplatesFailed = createAction(
  GETTING_MINIMAL_ATTACHMENT_TEMPLATES_FAILED
);

export const getAttachmentTemplateNamesByUuids = createAction(
  GET_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS
);

export const gettingAttachmentTemplateNamesByUuids = createAction(
  GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS
);

export const gettingAttachmentTemplateNamesByUuidsSucceeded = createAction(
  GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_SUCCEEDED
);

export const gettingAttachmentTemplateNamesByUuidsFailed = createAction(
  GETTING_ATTACHMENT_TEMPLATE_NAMES_BY_UUIDS_FAILED
);

export const gettingAttachmentTemplate = createAction(
  GETTING_ATTACHMENT_TEMPLATE
);

export const gettingAttachmentTemplateSucceeded = createAction(
  GETTING_ATTACHMENT_TEMPLATE_SUCCEEDED
);

export const gettingAttachmentTemplateFailed = createAction(
  GETTING_ATTACHMENT_TEMPLATE_FAILED
);

export const creatingAttachmentTemplate = createAction(
  CREATING_ATTACHMENT_TEMPLATE
);

export const creatingAttachmentTemplateSucceeded = createAction(
  CREATING_ATTACHMENT_TEMPLATE_SUCCEEDED
);

export const creatingAttachmentTemplateFailed = createAction(
  CREATING_ATTACHMENT_TEMPLATE_FAILED
);

export const updatingAttachmentTemplate = createAction(
  UPDATING_ATTACHMENT_TEMPLATE
);

export const updatingAttachmentTemplateSucceeded = createAction(
  UPDATING_ATTACHMENT_TEMPLATE_SUCCEEDED
);

export const updatingAttachmentTemplateFailed = createAction(
  UPDATING_ATTACHMENT_TEMPLATE_FAILED
);

export const deletingAttachmentTemplates = createAction(
  DELETING_ATTACHMENT_TEMPLATES
);

export const deletingAttachmentTemplatesSucceeded = createAction(
  DELETING_ATTACHMENT_TEMPLATES_SUCCEEDED
);

export const deletingAttachmentTemplatesFailed = createAction(
  DELETING_ATTACHMENT_TEMPLATES_FAILED
);

export const gettingAssociatedCampaignsForAttachmentTemplate = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE
);

export const gettingAssociatedCampaignsForAttachmentTemplateSucceeded = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_SUCCEEDED
);

export const gettingAssociatedCampaignsForAttachmentTemplateFailed = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_ATTACHMENT_TEMPLATE_FAILED
);

export const attachmentAutoSaveTimerStart = createAction(
  ATTACHMENT_AUTO_SAVE_TIMER_START
);

export const attachmentAutoSaveTimerEnd = createAction(
  ATTACHMENT_AUTO_SAVE_TIMER_END
);

export const setNextStep = createAction(SET_NEXT_STEP);
export const unsetNextStep = createAction(UNSET_NEXT_STEP);

export const getPaginatedAttachmentTemplates = createAction(
  GET_PAGINATED_ATTACHMENT_TEMPLATES
);

export const getMinimalAttachmentTemplates = createAction(GET_MINIMAL_ATTACHMENT_TEMPLATES);

export const getAttachmentTags = createAction(GET_ATTACHMENT_TAGS);
export const gettingAttachmentTags = createAction(GETTING_ATTACHMENT_TAGS);
export const gettingAttachmentTagsSucceeded = createAction(
  GETTING_ATTACHMENT_TAGS_SUCCEEDED
);
export const gettingAttachmentTagsFailed = createAction(
  GETTING_ATTACHMENT_TAGS_FAILED
);

export const setCopyCurrentAttachmentTemplate = createAction(
  SET_COPY_CURRENT_ATTACHMENT_TEMPLATE
);

export const updateAttachmentFilters = createAction(UPDATE_ATTACHMENT_FILTERS);

export const resetAttachmentFilters = createAction(RESET_ATTACHMENT_FILTERS);
// Test attachment template action creators (matches print template pattern)
export const getAttachmentTemplateFile = createAction(GET_ATTACHMENT_TEMPLATE_FILE);
export const gettingAttachmentTemplateFileSucceeded = createAction(GETTING_ATTACHMENT_TEMPLATE_FILE_SUCCEEDED);
export const gettingAttachmentTemplateFileFailed = createAction(GETTING_ATTACHMENT_TEMPLATE_FILE_FAILED);
export const downloadedAttachmentTemplateFile = createAction(DOWNLOADED_ATTACHMENT_TEMPLATE_FILE);
export const setAttachmentTestDownload = createAction(SET_ATTACHMENT_TEST_DOWNLOAD);
